import React, {useState, useContext, useEffect} from 'react';
import {useTranslate} from 'react-polyglot';
import '@rmwc/badge/badge.css';
import '../CustomLoaderMenu.css';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ColorPicker from '../../colorPicker/ColorPicker';
import InputFileDragAndDrop from '../../inputFileDragAndDrop/InputFileDragAndDrop'
import '@material/textfield/dist/mdc.textfield.css';
import { CustomLoaderContext } from '../../../context/CustomLoaderContext';
import {
    FontSizeOutlined,
    DownloadOutlined,
    PictureOutlined
  } from '@ant-design/icons';
import { Checkbox, TextField } from '@mui/material';

import { AVAILABLE_FONTS, getFontFamily } from '../availableFonts';


function QRScreenWTW(props) {

    const t = useTranslate();
    const [open,setOpen] = useState({
        title: '',
        subtitle: '',
        isOpen: false
    })
    const {
            qrWTWScreenSettings,
            updateQRWTWSettings,
            setChangesSaved,
        } = useContext(CustomLoaderContext);


    const [textSettingsOpen, setTextSettingsOpen] = useState(false);
    const [footerSettingsOpen, setFooterSettingsOpen] = useState(false);
    const [brandLogoSettingsOpen, setBrandLogoSettingsOpen] = useState(false);
    // const [backgroundSettingsOpen, setBackgroundSettingsOpen] = useState(false);

    // footer logo
    const flThemeColors = ["black", "white"];

    const closeAll = () => {
        setTextSettingsOpen(false);
        setBrandLogoSettingsOpen(false);
        setFooterSettingsOpen(false);
        // setBackgroundSettingsOpen(false);
    }
    
    const handleMenuClick = (currentState, openSetter) => {
        closeAll();
        openSetter(!currentState)
    }
    
    const handleUpdateSettings = (newSettings) => {
        setChangesSaved(false);
        updateQRWTWSettings(newSettings)
    }

    useEffect(() => {
        if (qrWTWScreenSettings.background.file) {
            updateQRWTWSettings({
                background: {
                    isGradiant: false,
                    isGrid: false
                }
            })
        }
    }, [qrWTWScreenSettings.background.file])


    return (
        <List>
            <ListItem button onClick={() => handleMenuClick(brandLogoSettingsOpen, setBrandLogoSettingsOpen)} className={brandLogoSettingsOpen ? "item-open menu-item-custom" : "item-close menu-item-custom"}>
                <PictureOutlined src={`/images/reports-hovered.svg`} style={{
                                            marginLeft: '8px',
                                            marginRight: '8px',
                                            width: '16px',
                                            height: '16px'
                                        }}/>
                <ListItemText primary={t('customLoaderSidebar.menu.screens.qrWTW.brandImage')} />
            </ListItem>
            <Collapse in={brandLogoSettingsOpen} unmountOnExit>
                <ListItem>
                    <InputFileDragAndDrop
                        id="brandLogo"
                        acceptedExtensions={".svg, .jpg, .jpeg, .png"}
                        setOpen={setOpen}
                        handleURL={(url) => handleUpdateSettings({brandImage: {url}})}
                        handleFile={(file) => handleUpdateSettings({brandImage: {file}})}
                        defaultFile={qrWTWScreenSettings.brandImage.local}
                        onFileLoaded={(filePath) => {
                            handleUpdateSettings({
                                brandImage: {
                                    local: filePath,
                                    reset: false,
                                }
                            })
                        }}
                        onQuitFile={() => {
                            handleUpdateSettings({
                                brandImage: {
                                    local: undefined,
                                    file: undefined,
                                    reset: true
                                }
                            })
                        }}
                    ></InputFileDragAndDrop>
                </ListItem>
            </Collapse>

            <ListItem button onClick={() => handleMenuClick(textSettingsOpen, setTextSettingsOpen)} className={textSettingsOpen ? "item-open menu-item-custom" : "item-close menu-item-custom"}>
                <FontSizeOutlined style={{
                                            marginLeft: '8px',
                                            marginRight: '8px',
                                            width: '16px',
                                            height: '16px'
                                        }} />
                <ListItemText primary={t('customLoaderSidebar.menu.screens.qrWTW.fonts')} />
            </ListItem>
            <Collapse in={textSettingsOpen}>
                    <ListItem>
                    <ColorPicker defaultColor={qrWTWScreenSettings.fonts.textColor} handleColor={(textColor) => handleUpdateSettings({fonts: {textColor}})}></ColorPicker>
                </ListItem>
                <ListItem className="text-field">
                    <select
                        className="select-header-font"
                        value={qrWTWScreenSettings.fonts.family}
                        style={{
                            fontFamily: getFontFamily(qrWTWScreenSettings.fonts.family),
                            fontWeight: 'normal'
                        }}
                        onChange={(e) => handleUpdateSettings({fonts: {family: e.target.value}})}
                        label=" "
                    >
                        {
                            AVAILABLE_FONTS.map((font) => {
                                return (
                                    <option 
                                        key={`font-${font.name}`} 
                                        value={font.name}
                                        style={{ fontFamily: font.normal.fontFamily, fontWeight: font.normal.fontWeight, fontSize: '16px', padding: '8px' }}
                                    >
                                        {font.name}
                                    </option>
                                )
                            })
                        }
                    </select>
                </ListItem>
            </Collapse>

            <ListItem button onClick={() => handleMenuClick(footerSettingsOpen, setFooterSettingsOpen)} className={footerSettingsOpen ? "item-open menu-item-custom" : "item-close menu-item-custom"}>
                <DownloadOutlined style={{marginLeft: '8px', marginRight: '8px', width: '16px', height: '16px'}}/>
                <ListItemText primary={t('customLoaderSidebar.menu.screens.qrWTW.footer')} />
            </ListItem>
            <Collapse in={footerSettingsOpen} className='footer-container'>
                <ListItem className="text-field">
                    <select
                        className="select-footer-theme-color"
                        value={qrWTWScreenSettings.footerThemeColor}
                        onChange={(e)=>handleUpdateSettings({footerThemeColor: e.target.value})}
                        label=" "
                    >
                        {
                            flThemeColors.map((l) => {
                                return <option key={`theme-${l}`} value={l}>{t(`customLoaderSidebar.menu.screens.qrWTW.${l}`)}</option>
                                
                            })
                        }
                    </select>
                </ListItem>
                <ListItem>
                    <InputFileDragAndDrop
                        id="loadingFooterLogo"
                        acceptedExtensions={".svg, .jpg, .jpeg, .png"}
                        setOpen={setOpen}
                        handleURL={(url)=>handleUpdateSettings({footerImage: {url}})}
                        handleFile={(file)=>handleUpdateSettings({footerImage: {file}})}
                        defaultFile={qrWTWScreenSettings.footerImage.local}
                        onFileLoaded={(filePath) => {
                            handleUpdateSettings({
                                footerImage: {
                                    local: filePath,
                                    reset: false
                                }
                            })
                        }}
                        onQuitFile={() => {
                            handleUpdateSettings({
                                footerImage: {
                                    local: undefined,
                                    file: undefined,
                                    reset: true
                                }
                            })
                        }}
                    ></InputFileDragAndDrop>
                </ListItem>
            </Collapse>

            {/* <ListItem button onClick={() => handleMenuClick(backgroundSettingsOpen, setBackgroundSettingsOpen)} className={backgroundSettingsOpen ? "item-open menu-item-custom" : "item-close menu-item-custom"}>
                <PictureOutlined src={`/images/reports-hovered.svg`} style={{
                                            marginLeft: '8px',
                                            marginRight: '8px',
                                            width: '16px',
                                            height: '16px'
                                        }}/>
                <ListItemText primary={t('customLoaderSidebar.menu.screens.qrWTW.background')} />
            </ListItem>
            <Collapse in={backgroundSettingsOpen} unmountOnExit>
                <ListItem>
                    <div className='background-item-container'>
                        <ColorPicker
                            disabled={qrWTWScreenSettings.background.local}
                            defaultColor={qrWTWScreenSettings.background.color}
                            handleColor={(color)=>handleUpdateSettings({background: {color}})}>
                        </ColorPicker>

                        { qrWTWScreenSettings.background.isGradiant &&
                            <ColorPicker
                                disabled={qrWTWScreenSettings.background.local}
                                defaultColor={qrWTWScreenSettings.background.gradiantColor}
                                handleColor={(gradiantColor)=>handleUpdateSettings({background: {gradiantColor}})}>
                            </ColorPicker>
                        }
                        <div>
                            <Checkbox
                                disabled={qrWTWScreenSettings.background.local}
                                checked={qrWTWScreenSettings.background.isGradiant}
                                onChange={(e)=>handleUpdateSettings({background: {isGradiant: e.target.checked}})}/> {t('customLoaderSidebar.menu.screens.qrWTW.gradiant')}
                        </div>
                        <div>
                            <Checkbox
                                disabled={qrWTWScreenSettings.background.local}
                                checked={qrWTWScreenSettings.background.isGrid}
                                onChange={(e)=>handleUpdateSettings({background: {isGrid: e.target.checked}})}/>{t('customLoaderSidebar.menu.screens.qrWTW.grid')}                            
                        </div>
                        <InputFileDragAndDrop
                            id="backgroundFile"
                            acceptedExtensions={".svg, .jpg, .jpeg, .png"}
                            setOpen={setOpen}
                            handleURL={(url) => handleUpdateSettings({background: {url}})}
                            handleFile={(file) => handleUpdateSettings({background: {file}})}
                            defaultFile={qrWTWScreenSettings.background.local}
                            onFileLoaded={(filePath) => {
                                handleUpdateSettings({
                                    background: {
                                        local: filePath,
                                        //file: file => handleUpdateSettings({background: {file}}),
                                        reset: false,
                                        isGrid: false,
                                    }
                                })
                            }}
                            onQuitFile={() => {
                                handleUpdateSettings({
                                    background: {
                                        file: undefined,
                                        local: undefined,
                                        reset: true,
                                        isGrid: true,
                                    }
                                })
                            }}
                        ></InputFileDragAndDrop>
                    </div>
                </ListItem>
            </Collapse> */}
        </List>
    );
}

export default QRScreenWTW;
